<div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--10 fdx-u-mt--10">
  <div
    class="fdx-o-grid__item fdx-o-grid__item--12@large fdx-o-grid__item--11 fdx-u-align--center">
    <h1 class="fdx-c-heading fdx-c-heading--h1">
      {{ title }}
    </h1>
    <p class="fdx-c-heading fdx-c-heading--h4 fdx-u-mt--5">
      <ng-content></ng-content>
    </p>
  </div>
</div>
